import { render, staticRenderFns } from "./New.vue?vue&type=template&id=4c6c5b3c&lang=pug&"
import script from "./New.vue?vue&type=script&lang=ts&"
export * from "./New.vue?vue&type=script&lang=ts&"
import style0 from "./New.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports